import { render, staticRenderFns } from "./EditBsn.vue?vue&type=template&id=2c5f4c7c&"
import script from "./EditBsn.vue?vue&type=script&lang=js&"
export * from "./EditBsn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports